<template lang="html">
    <div>
        <div class="d-flex flex-row align-items-center">
            <div class="row g-0 align-self-center align-items-center justify-content-center">
                <div class="cta-3 text-primary">Réponse acceptée</div>
            </div>


            <button  @click="delete_state()" type="button" class="btn btn-outline-primary btn-sm btn-icon btn-icon-only ms-auto" ><i class="bi-trash"></i></button>
        </div>

        <div class="text-alternate">{{ human_created_on  }}</div>
        <div class="text-success d-flex align-items-center mt-2"
             v-if=" context.data.answer.validated_by==null">
            <i class="d-inline-block icon-16 bi-check2-circle me-2" ></i>
            Réponse validée par personne
        </div>
        <div class="text-success d-flex align-items-center mt-2"
             v-else>
            <i class="d-inline-block icon-16 bi-check2-circle me-2" ></i>
            Réponse validée par {{ context.data.answer.validated_by }}
        </div>
        <div class="btn-group mt-2 mb-2" role="group" >
            <button type="button"
                    class="btn btn-sm btn-outline-primary"
                    @click="copy_publish(context.data.answer.text_fr)">
                Copier & publier (FR)
            </button>
            <button type="button"
                    class="btn btn-sm btn-outline-primary"
                    @click="copy(context.data.answer.text_fr)">
                Copier (FR)
            </button>
            <button type="button"
                    class="btn btn-sm btn-outline-primary"
                    v-if="context.data.answer.text_native != null"
                    @click="copy(context.data.answer.text_native)">
                Copier ({{review.native_lang.code}})
            </button>
            <button type="button"
                    class="btn btn-sm btn-outline-primary"
                    v-if="context.data.answer.text_native != null"
                    @click="copy_publish(context.data.answer.text_native)">
                Copier & publier ({{review.native_lang.code}})
            </button>
        </div>


        <div class="d-flex align-items-center mt-3 pt-2 border-top mb-2">
            <img src="@/assets/img/profile/flag-french.png"
                 width="18px"
                 height="18px"
                 class="me-2">
            Version française
        </div>
        <p style="white-space: break-spaces;">{{context.data.answer.text_fr}}</p>
        <div class="btn-group mt-2" role="group" >
            <button type="button"
                    class="btn btn-sm btn-outline-primary"
                    @click="copy_publish(context.data.answer.text_fr)">
                Copier & publier (FR)
            </button>
            <button type="button"
                    class="btn btn-sm btn-outline-primary"
                    @click="copy(context.data.answer.text_fr)">
                Copier (FR)
            </button>
        </div>

        <div v-if="context.data.answer.text_native != null">
            <div class="d-flex align-items-center border-top mt-3 pt-2 mb-2">
                <img src="@/assets/img/profile/flag-eng.png"
                     width="18px"
                     height="18px"
                     class="me-2">
                Traduite
            </div>
            <p style="white-space: break-spaces;">{{context.data.answer.text_native}}</p>
            <div class="btn-group mt-2" role="group" >
                <button type="button"
                        class="btn btn-sm btn-outline-primary"
                        @click="copy(context.data.answer.text_native)">
                    Copier
                </button>
                <button type="button"
                        class="btn btn-sm btn-outline-primary"
                        @click="copy_publish(context.data.answer.text_native)">
                    Copier & publier
                </button>
            </div>
        </div>
        <div v-if="context.data.text_history" class="pt-3">
            <h3>Historique ({{context.data.text_history.length}} Modification(s))</h3>
            <table class="table history-table">
                <tr>
                    <td style="font-weight:bold;">Avant</td>
                    <td style="font-weight:bold;">Après</td>
                </tr>
                <template v-for="mod in text_history_ordered">
                <tr>
                    <td colspan="2" style="font-weight:bold;">
                        {{mod.user.repr}}
                        <span :title="mod.date">
                            {{mod.date|from_now}}
                        </span>
                    </td>
                </tr>
                <tr>
                    <td><div class="history-cell">{{mod.before}}</div></td>
                    <td><div class="history-cell" v-html="modified(mod.before, mod.after)"></div></td>
                </tr>
                </template>
            </table>
        </div>
        
    </div>
</template>

<script>
import CONNECTION_FOR_REVIEW from '@/gql/queries/connectionForReview.graphql';
import { gqlQuery } from '@/gqlClient.js';
import moment from "moment";
import diff from "diff";
moment.locale("fr");

export default {
  name: "StateAnswerAccepted",
  props: {
    context: {
      type: Object,
      required: true
    },
    review: {
      type: Object,
      required: true
    },
    human_created_on: String
  },
  computed: {
    human_published_on() {
      return moment(this.context.updated_on).fromNow();
    },
    text_history_ordered() {
      let ret = [];
      if (this.context.data.text_history) {
        ret = this.context.data.text_history.sort((a, b) => {
          return new Date(b.date).getTime() - new Date(a.date).getTime();
        });
      }
      return ret;
    }
  },
  methods: {
    modified(before, after) {
      if (!before) before = "";
      if (!after) after = "";
      const text_diff = diff.diffWords(before, after);
      let out = "";
      for (const part of text_diff) {
        if (part.added) {
          out += '<span style="background-color:#cefacb;">' + part.value + '</span>';
        } else if (part.removed) {
          out += '<span style="background-color:#facbcb;">' + part.value + '</span>';
        } else {
          out += part.value;
        }
      }
      return out;
    },
    copy_publish(text) {
      this.copy(text);
      gqlQuery(CONNECTION_FOR_REVIEW, { uid: this.context.review.uid }).then((resp) => {
        const data = JSON.parse(resp.body.data.connection_set_for_review);
        window.open(data.establishment_link, "_blank").focus();
      });
    },
    copy(text) {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.top = "0";
      textArea.style.left = "0";
      textArea.style.position = "fixed";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
      this.$store.dispatch("notify", {
        level: "success",
        text: "Copié!",
        seconds: 2
      });
    },
    delete_state() {
      this.$emit("state:delete_state");
    }
  }
};
</script>

<style lang="scss" scoped>
.history-table {
  table-layout: fixed;
  width: 100%;
}

.history-cell {
  white-space: pre-wrap;
  word-break: break-word;
  overflow-wrap: break-word;
  font-family: inherit;
}
</style>
